import hash from "object-hash";
const defaultOmittedKeys = ["_id", "created", "updated", "invalidated", "type", "timestamp"];
export function clean(o, omittedKeys = defaultOmittedKeys) {
  if (!o) {
    return void 0;
  }
  return Object.entries(o).reduce((a, [key, value]) => {
    if (!omittedKeys.includes(key)) {
      a[key] = value === null ? void 0 : value;
    }
    return a;
  }, {});
}
export function compare(first, second) {
  return !first || !second ? false : hash(clean(first)) === hash(clean(second));
}
//# sourceMappingURL=clean.js.map
